// @ts-ignore Untyped module eventBus
import bus from 'ContentEditorUI/coffee/lib/eventBus';
import { TourSyncController } from 'ContentEditorUI/controllers/TourSyncController';
import { SECTIONS_LIBRARY_TOUR } from 'ContentEditorUI/constants/tours';
import { jsx as _jsx } from "react/jsx-runtime";
export const SectionsLibraryOnboardingTourController = () => {
  return /*#__PURE__*/_jsx(TourSyncController, {
    bus: bus,
    tourKey: SECTIONS_LIBRARY_TOUR,
    tourEnv: "parent"
  });
};